// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item[data-v-3320324c]{background:transparent;border:1px solid transparent;border-radius:.4rem;display:block;margin:0;padding:.2rem .4rem;text-align:left;width:100%}.item.is-selected[data-v-3320324c]{--tw-bg-opacity:1;background-color:#cad6ed}@supports (color:rgb(0 0 0/0)){.item.is-selected[data-v-3320324c]{background-color:rgb(202 214 237/var(--tw-bg-opacity,1))}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
